import React from 'react'
import { createTheme, ThemeProvider } from '@atd/rui-base.theme.theme-provider'
import { ravenLightTheme } from '@atd/rui-base.theme.raven-themes'

export const ravenThemeV5 = createTheme(ravenLightTheme, {
    shape: { borderRadius: 2 },
    components: {
        MuiButton: { styleOverrides: { root: { verticalAlign: 'middle' } } },
    },
})

export function RavenThemeScope({ children }) {
    return <ThemeProvider lightTheme={ravenThemeV5} initialMode="light">{children}</ThemeProvider>
}

export const DIALOG_MENU_PROPS = { style: { zIndex: 2200 } }

export const CARD_SX = {
    borderRadius: '2px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
}
